import request from "@utils/request";
/**
 * 选配信息初始化
 *
 * @param carSeriesId 车系Id 1-007 2-Z03 3-A06 4-V09
 * @return
 */
export function initSeries(data) {
  return request({
    url: "/hycanapp/noAuth/front/ssh/optional/init",
    method: "get",
    params: data,
  });
}

/**
 * 车型版本列表查询
 *
 * @param carSeriesId 车系Id 1-007 2-Z03 3-A06 4-V09
 * @return
 */
export function getCarTypeList(data) {
  return request({
    url: `/hycanapp/noAuth/front/ssh/car-type/list`,
    method: "get",
    params: data,
  });
}

/**
 * 车型更新
 *
 * @param request
 * @return
 */
export function updateCarType(data) {
  return request({
    url: `/hycanapp/noAuth/front/ssh/car-type/update`,
    method: "POST",
    data: data,
  });
}

/**
 * 获取车型选配信息列表
 *
 * @param carSeriesId 车系Id 1-007 2-Z03 3-A06 4-V09
 * @param carTypeId 车型Id
 * @return
 */
export function getOptionalList(data) {
  return request({
    url: `/hycanapp/noAuth/front/ssh/optional/list`,
    method: "GET",
    params: data,
  });
}

/**
 * 选配信息更新
 *
 * @param request
 * @return
 */
export function updateOptional(data) {
  return request({
    url: `/hycanapp/noAuth/front/ssh/optional/update`,
    method: "POST",
    data: data,
  });
}

/**
 * 获取下单页权益
 *
 * @param request
 * @return
 */
export function getEquity(data) {
  return request({
    url: `/hycanapp/simpleAuth/front/ssh/order/equity/get`,
    method: "GET",
    params: data,
  });
}

/**
 * 获取默认值
 *
 * @param request
 * @return
 */
export function getDefaultData(data) {
  return request({
    url: `/hycanapp/user/simpleAuth/front/ssh/getUser`,
    method: "GET",
    params: data,
  });
}

/**
 * 下单
 *
 * @param request
 * @return
 */
export function order(data) {
  return request({
    url: `/hycanapp/simpleAuth/front/ssh/order/create`,
    method: "POST",
    data: data,
  });
}

/**
 * 订单状态查询
 *
 * @param request
 * @return
 */
export function getStatus(id) {
  return request({
    url: `/hycanapp/noAuth/front/ssh/order/pay/status`,
    method: "GET",
    params: {
      carOrderBaseId: id,
    },
  });
}

// 成功页查询
export function getOrderDetail(id) {
  return request({
    url: `/order/bigCarOrder/simpleAuth/front/officialWebsite/orderDetail`,
    method: "GET",
    params: {
      carOrderBaseId: id,
    },
  });
}

// 获取城市
export function get4City() {
  return request({
    method: "POST",
    url: "/commserv/address/get4City",
    data: {},
  });
}

// 获取服务门店
export function getDmsShopByNumber(params) {
  return request({
    method: "get",
    url: `/maintenance/offlineExperienceShop/noAuth/front/v3.2.4.5/getShopListSimple`,
    params,
    // params: {
    //   authorizeCityAdCode: number,
    // },
  });
}

// 经纬度获取最近门店
export function getDmsShopByCoord(data) {
  return request({
    method: "get",
    url: `/maintenance/offlineExperienceShop/simpleAuth/front/ssh/gaode/getDmsShopByCoord`,
    params: data,
  });
}

/**
 * 获取心愿单详情
 *
 * @param request
 * @return
 */
export function getWishMsg(data) {
  return request({
    url: `/order/carConfigUserWish/simpleAuth/front/v3.3.2/getWishMsg`,
    method: "GET",
    params: data,
  });
}

/**
 * 获取版本差异url
 *
 * @param request
 * @return
 */
export function getCarVersionAgreement(data) {
  return request({
    url: `/hycanapp/noAuth/front/ssh/carSale/getCarVersionAgreement`,
    method: "GET",
    params: data,
  });
}

/**
 * 获取定金，列表第一项finalPayment
 *
 * @param request
 * @return
 */
export function getBuyTypeList(data) {
  return request({
    url: `/hycanapp/carSaleApolegamy/simpleAuth/front/ssh/getBuyTypeList`,
    method: "GET",
    params: {
      carOrderBaseId: data.carOrderBaseId || "",
      carConfigSeriesId: data.carConfigSeriesId,
    },
  });
}

/**
 * 获取官网查询预定协议
 *
 * @param request
 * @return
 */
export function getOrderAgreement(data) {
  return request({
    url: `/order/carConfigAtt/noAuth/front/officialWebsite/orderAgreement`,
    method: "GET",
    params: {
      carSeriesId: data.carSeriesId,
    },
  });
}
